import React from 'react'
import type { Chat } from '@ztechapps/common.contract'
import { HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { UpdateConversationStatusButton } from './UpdateConversationStatusButton'

type LastBreadcrumbItemProps = {
  code?: string
  // VL-8: the same detail document ConversationDetail.tsx already loaded (useDocument +
  // conversationDetailsQuery) — passed through so the status control reads it too instead of
  // its own lookup into the inbox list page's `chatList`, which is empty for a conversation
  // opened off that page.
  chat?: Chat
}

// Sales-shaped last breadcrumb (apps/panelpunches/admin/src/view/sales/item/LastBreadcrumbItem.tsx):
// the live status control first, then the document code beside it. Both arrive as props from the
// inbox detail mount — this crumb renders them only and never reads the inbox list itself. The
// subject is the thread's title row (InboxThreadLayout.tsx), not part of the trail.
export const LastBreadcrumbItem = ({ code, chat }: LastBreadcrumbItemProps) => {
  return (
    <HorizontalStack gap={2}>
      <div className="border-bottom border-2 pb-1 border-primary">
        <UpdateConversationStatusButton chat={chat} />
      </div>
      <ShowIf condition={!!code}>
        <div className="text-nowrap">{code}</div>
      </ShowIf>
    </HorizontalStack>
  )
}
